/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ValidateSocialPostBody
 */
export interface ValidateSocialPostBody {
    /**
     * The objective being claimed. When present, its socialPolicy is authoritative — hashtags, platforms and the per-period cap are campaign policy and live on the objective, so one EventType serves every campaign.
     * @type {string}
     * @memberof ValidateSocialPostBody
     */
    objectiveTemplateId?: string;
    /**
     * EventType the submission satisfies.
     * @type {string}
     * @memberof ValidateSocialPostBody
     */
    eventTypeId: string;
    /**
     * Public post URL on a supported platform.
     * @type {string}
     * @memberof ValidateSocialPostBody
     */
    postUrl: string;
    /**
     * Optional platform hint (tiktok | instagram | facebook | twitter | youtube | reddit). When omitted the server detects from the URL.
     * @type {string}
     * @memberof ValidateSocialPostBody
     */
    platform?: string;
}

/**
 * Check if a given object implements the ValidateSocialPostBody interface.
 */
export function instanceOfValidateSocialPostBody(value: object): value is ValidateSocialPostBody {
    if (!('eventTypeId' in value) || value['eventTypeId'] === undefined) return false;
    if (!('postUrl' in value) || value['postUrl'] === undefined) return false;
    return true;
}

export function ValidateSocialPostBodyFromJSON(json: any): ValidateSocialPostBody {
    return ValidateSocialPostBodyFromJSONTyped(json, false);
}

export function ValidateSocialPostBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ValidateSocialPostBody {
    if (json == null) {
        return json;
    }
    return {
        
        'objectiveTemplateId': json['objectiveTemplateId'] == null ? undefined : json['objectiveTemplateId'],
        'eventTypeId': json['eventTypeId'],
        'postUrl': json['postUrl'],
        'platform': json['platform'] == null ? undefined : json['platform'],
    };
}

export function ValidateSocialPostBodyToJSON(json: any): ValidateSocialPostBody {
    return ValidateSocialPostBodyToJSONTyped(json, false);
}

export function ValidateSocialPostBodyToJSONTyped(value?: ValidateSocialPostBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectiveTemplateId': value['objectiveTemplateId'],
        'eventTypeId': value['eventTypeId'],
        'postUrl': value['postUrl'],
        'platform': value['platform'],
    };
}

